import {ResolvedGallery, ResolvedPhoto} from "../types";
import {Box, Card, CardActionArea, CardContent, CardMedia, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import React from "react";

export function GalleryThumbs(props: { g: ResolvedGallery }) {
    const col1Width = 206;
    const col2Width = 70;

    const photos = GetGalleryThumbnailPhotos(props.g);

    return <div style={{display: "grid", gridTemplateColumns: {col1Width} +", " + {col2Width}}}>
        <img src={photos[0].sizeUrls[2].url} height={180} width={col1Width} alt=""
             style={{objectFit: "cover", gridColumn: "1", gridRow: "1"}}/>
        <div style={{display: "grid", gridColumn: "2", gridRow: "1"}}>
            <img src={photos[1].sizeUrls[2].url} height={60} width={col2Width} alt=""
                 style={{objectFit: "cover", gridColumn: "1", gridRow: "1"}}/>
            <img src={photos[2].sizeUrls[2].url} height={60} width={col2Width} alt=""
                 style={{objectFit: "cover", gridColumn: "1", gridRow: "2"}}/>
            <img src={photos[3].sizeUrls[2].url} height={60} width={col2Width} alt=""
                 style={{objectFit: "cover", gridColumn: "1", gridRow: "3"}}/>
        </div>
    </div>;
}

export function GetGalleryThumbnailPhotos(gallery: ResolvedGallery): ResolvedPhoto[] {
    const arr = [gallery.cover!, ...gallery.photos];
    const seen = new Set<any>();
    const result: ResolvedPhoto[] = [];

    for (const item of arr) {
        const value = item?.id;
        if (!seen.has(value)) {
            seen.add(value);
            result.push(item);
            if (result.length === 4) break;
        }
    }

    return result;
}

export function GalleriesList(props: { galleries: ResolvedGallery[] }) {
    return <Box
        sx={{
            // display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
            //justifyContent: "center",
            justifyItems: "center",
            alignItems: "center",
            gap: 2,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between"

        }}
    >
        {props.galleries.map((g) => (
            <Card variant="outlined" key={g.id} style={{
                borderRadius: 0,
                overflow: "hidden",
                border: "0px solid rgba(255,255,255,0.12)",
                padding: 0,
                background: "transparent"
            }}>
                <CardActionArea component={Link} to={`/g/${encodeURIComponent(g.id)}`}>
                    {g.cover?.sizeUrls[2].url && (
                        <>
                            <CardMedia component="div">
                                <GalleryThumbs g={g}/>
                            </CardMedia>
                        </>
                    )}
                    <CardContent>
                        <Typography variant="subtitle1">{g.title}</Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        ))}
    </Box>;
}